import { ArrowUpRight } from "lucide-react";
import { ORDER_URL } from "@/data/menu";
import { Reveal } from "@/components/Reveal";

export const HowToOrder = () => (
  <section id="how" data-testid="how-section" className="bg-brand-alt py-24 md:py-32">
    <div className="mx-auto max-w-7xl px-6 lg:px-8">
      <Reveal>
        <p className="text-xs font-semibold uppercase tracking-[0.25em] text-brand-accent md:text-sm">
          <span className="mr-3 font-light text-brand-dark/35">02 /</span>
          КАК ДА ПОРЪЧАТЕ?
        </p>
        <div className="mt-6 max-w-3xl space-y-4 text-sm font-light leading-relaxed text-brand-gray md:text-base">
          <p>
            Изберете желаните предложения от менюто на B1 &amp; B2 и ги заявете
            директно към екипа на Детски парти клуб „Българче“ заедно с
            останалите детайли по вашето парти.
          </p>
          <p className="font-medium text-brand-dark">
            „Българче“ приема цялата заявка за събитието, а B1 &amp; B2 приготвя
            и доставя избраните кетъринг предложения.
          </p>
        </div>
      </Reveal>

      <Reveal delay={150}>
        <a
          href={ORDER_URL}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="cta-how-order"
          className="mt-10 inline-flex items-center gap-2 rounded-full bg-brand-accent px-8 py-4 text-sm font-semibold uppercase tracking-wide text-white transition hover:bg-brand-accentHover active:scale-[0.98]"
        >
          Заявете към „Българче“
          <ArrowUpRight className="h-4 w-4" aria-hidden="true" />
        </a>
      </Reveal>
    </div>
  </section>
);
